import { SocialPostType } from '@anytag/graphql';
import { getToday, getThirtyDaysAgo } from '@anytag/shared-utils';
import { PostsFilterFormValues } from './schemaTypes';

export const defaultPostsFilterValues: PostsFilterFormValues = {
  sort: '', // sort for selector = `${field}-${order}
  field: null,
  order: null,
  keyword: '',
  genders: [],
  minViews: '',
  maxViews: '',
  countryId: '',
  categoryIds: [],
  minFollowers: '',
  maxFollowers: '',
  minEngagementRate: '',
  maxEngagementRate: '',
  maxPostDate: getToday(),
  minPostDate: getThirtyDaysAgo(),
  socialMedia: SocialPostType.INSTAGRAM
};
